// extracted by mini-css-extract-plugin
export default {"errorContainer":"errorBoundary_errorContainer__UOfqx","backButton":"errorBoundary_backButton__-HTMP"};